<div class="custom-modal-layout">
  <div class="modal-header" style="margin-bottom: 5px !important;">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Email Icon" />
    </div>
    <span class="title">Nova empresa gestora</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()"></p-button>
  </div>

  <form [formGroup]="addEmpresaGestoraForm" (ngSubmit)="save()">
    <p-stepper [(value)]="activeStep" class="basis-[50rem]">
      <p-step-panels>
        <p-step-panel [value]="1">
          <ng-template #content let-activateCallback="activateCallback">
            <div class="p-fluid grid">
              <div class="field col-12">
                <div class="file-upload">
                  <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
                    accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000"
                    invalidFileTypeMessageSummary="danger"
                    invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido"
                    invalidFileLimitMessageSummary="danger"
                    invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
                    <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
                      let-uploadCallback="uploadCallback">
                    </ng-template>
                    <ng-template #content let-files let-uploadedFiles="uploadedFiles"
                      let-removeFileCallback="removeFileCallback" let-chooseCallback="chooseCallback"
                      let-removeUploadedFileCallback="removeUploadedFileCallback">
                      <a class="circular-upload preview"
                        [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                        <span *ngIf="!imagePreview">Foto</span>
                        <div class="icon" (click)="choose($event, chooseCallback)">
                          <img src="icons/camera-01.svg" alt="">
                        </div>
                      </a>
                      <!-- <button pButton type="button" label="Guardar Foto" class="p-button-primary mt-2" (click)="savePhoto()"></button> -->
                    </ng-template>
                    <ng-template #file></ng-template>
                    <ng-template #empty></ng-template>
                  </p-fileupload>
                </div>
              </div>
              <div class="field col-12">
                <label for="name">Nome da Empresa Gestora <span class="text-red-500">*</span></label>
                <input id="name" type="text" class="w-full" pInputText formControlName="Nome"
                  placeholder="Nome da Empresa gestora" />
                <div *ngIf="addEmpresaGestoraForm.get('Nome')?.invalid && addEmpresaGestoraForm.get('Nome')?.touched"
                  class="error-message">
                  Nome da empresa gestora é obrigatório
                </div>
              </div>

              <div class="field col-6">
                <label for="natureza">Natureza <span class="text-red-500">*</span></label>
                <p-select id="natureza" class="w-full" optionLabel="designacao" optionValue="id" [options]="naturezasID"
                  placeholder="Seleccione a natureza da empresas" formControlName="Natureza"></p-select>
                <div
                  *ngIf="addEmpresaGestoraForm.get('Natureza')?.invalid && addEmpresaGestoraForm.get('Natureza')?.touched"
                  class="error-message">
                  Natureza da empresa é obrigatório
                </div>
              </div>

              <div class="field col-6">
                <label for="site">Website da Empresa</label>
                <input id="site" type="url" class="w-full" pInputText formControlName="Site"
                  placeholder="Informe o site da empresa" />
              </div>
              <!-- Country Dropdown -->
              <div class="field col-6 d-flex flex-column">
                <label for="telefone1">Telefone Principal <span class="text-red-500">*</span></label>
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <p-button icon="pi pi-globe" severity="secondary" variant="text" aria-label="Selecionar país"
                      (click)="menu.toggle($event)" />
                  </p-inputgroup-addon>
                  <p-inputmask id="telefone1" [mask]="telefoneMask" [placeholder]="telefonePlaceholder"
                    formControlName="telefone1" class="w-full d-contents"></p-inputmask>
                </p-inputgroup>
                <p-menu #menu [model]="countryMenuItems" appendTo="body" popup styleClass="!min-w-fit" />
                <div
                  *ngIf="addEmpresaGestoraForm.get('telefone1')?.invalid && addEmpresaGestoraForm.get('telefone1')?.touched"
                  class="error-message">
                  Telefone principal é obrigatório e deve ser um número válido
                </div>
              </div>

              <div class="field col-6 d-flex flex-column">
                <label for="telefone2">Telefone Secundário <span class="text-red-500">*</span></label>
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <p-button icon="pi pi-globe" severity="secondary" variant="text" aria-label="Selecionar país"
                      (click)="menu.toggle($event)" />
                  </p-inputgroup-addon>
                  <p-inputmask id="telefone2" [mask]="telefoneMask" [placeholder]="telefonePlaceholder"
                    formControlName="telefone2" class="w-full d-contents"></p-inputmask>
                </p-inputgroup>
              </div>

              <div class="field col-6">
                <label for="email">Email <span class="text-red-500">*</span></label>
                <input id="email" type="text" class="w-full" pInputText formControlName="email" placeholder="Email" />
                <div *ngIf="addEmpresaGestoraForm.get('email')?.invalid && addEmpresaGestoraForm.get('email')?.touched"
                  class="error-message">
                  Email é obrigatório e deve ser válido
                </div>
              </div>

              <div class="field col-6">
                <label for="country">País da Instituição</label>
                <p-select [showClear]="true" [filter]="true" appendTo="body" id="paisID" class="w-full"
                  optionLabel="designacao" optionValue="id" [options]="countries" placeholder="Seleccione o país"
                  formControlName="paisID" />
                <div
                  *ngIf="addEmpresaGestoraForm.get('paisID')?.touched && addEmpresaGestoraForm.get('paisID')?.invalid">
                  <small class="error-message" *ngIf="addEmpresaGestoraForm.get('paisID')?.errors?.['required']">
                    País é obrigatório.
                  </small>
                </div>
              </div>

              <div class="field col-6">
                <label for="province">Província ou Estado da Instituição</label>
                <p-select [showClear]="true" [filter]="true" appendTo="body" id="provinciaID" class="w-full"
                  optionLabel="designacao" optionValue="id" [options]="provinces" placeholder="Seleccione a província"
                  formControlName="ProvinciaID" />
                <div
                  *ngIf="addEmpresaGestoraForm.get('ProvinciaID')?.touched && addEmpresaGestoraForm.get('ProvinciaID')?.invalid">
                  <small class="error-message" *ngIf="addEmpresaGestoraForm.get('ProvinciaID')?.errors?.['required']">
                    Província ou Estado é obrigatório.
                  </small>
                </div>
              </div>

              <div class="field col-6">
                <label for="municipioID">Município da Instituição</label>
                <p-select [showClear]="true" [filter]="true" appendTo="body" id="municipioID" class="w-full"
                  optionLabel="designacao" optionValue="id" [options]="municipalities"
                  placeholder="Seleccione o município" formControlName="MunicipioID" />
                <div
                  *ngIf="addEmpresaGestoraForm.get('MunicipioID')?.touched && addEmpresaGestoraForm.get('MunicipioID')?.invalid">
                  <small class="error-message" *ngIf="addEmpresaGestoraForm.get('MunicipioID')?.errors?.['required']">
                    Município é obrigatório.
                  </small>
                </div>
              </div>


              <div class="field col-12">
                <label for="endereco">Endereço</label>
                <input id="endereco" type="text" class="w-full" pInputText formControlName="Endereco"
                  placeholder="Endereço" />
                <div
                  *ngIf="addEmpresaGestoraForm.get('Endereco')?.touched && addEmpresaGestoraForm.get('Endereco')?.invalid">
                  <small class="error-message" *ngIf="addEmpresaGestoraForm.get('Endereco')?.errors?.['required']">
                    Endereço é obrigatório.
                  </small>
                </div>
              </div>

              <!-- <div class="field col-6">
                <label>Activar Empresa gestora?</label>
                <div class="flex flex-wrap gap-4">
                  <div class="flex items-center">
                    <p-radioButton [value]="true" formControlName="Activo" inputId="isActive1"></p-radioButton>
                    <label for="isActive1" class="ml-2">Sim</label>
                  </div>
                  <div class="flex items-center">
                    <p-radioButton [value]="false" formControlName="Activo" inputId="isActive2"></p-radioButton>
                    <label for="isActive2" class="ml-2">Não</label>
                  </div>
                </div>
              </div> -->
            </div>
            <div class="modal-footer" style="margin-top: -10px !important;">
              <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
              <p-button type="submit" label="Adicionar" class="p-button-primary"></p-button>
            </div>
          </ng-template>
        </p-step-panel>
      </p-step-panels>
    </p-stepper>
  </form>
</div>
<p-toast></p-toast>